import { apiInterfaceForJson } from '../common/apiManager';

export const fetchQcReports = () => {
    return apiInterfaceForJson('/qcReport/v1/', 'GET');
};

export const getRecentQcReports = () => {
    return apiInterfaceForJson('/qcReport/v1/recent', 'GET');
};

export const getQcReportDataById = (qcReportId) => {
    return apiInterfaceForJson('/qcReport/v1/' + qcReportId, 'GET');
};

export const createQcReport = (qcReportDetails) => {
    return apiInterfaceForJson('/qcReport/v1/', 'POST', qcReportDetails);
};

export const updateQcReport = (qcReportDetails) => {
    return apiInterfaceForJson('/qcReport/v1/', 'PUT', qcReportDetails);
};

export const deleteQcReport = (qcReportDetails) => {
    return apiInterfaceForJson('/qcReport/v1/delete', 'POST', qcReportDetails);
};
